import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      
      {/* Sticky mobile consultation button */}
      <div className="fixed bottom-6 left-0 right-0 z-40 px-4 md:hidden">
        <button
          onClick={() => {
            const element = document.getElementById('contact');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}
          className="w-full bg-gold text-navy px-6 py-4 rounded-lg text-base font-manrope font-semibold shadow-2xl hover:bg-gold-light transition-all duration-300 hover:scale-105"
        >
          Book Consultation
        </button>
      </div>
    </div>
  );
};

export default Home;